module.exports = __webpack_public_path__ + "static/007_Pantry-d9984dd6194b66ea5ed53c8f00d64f46.jpg";